import HolidayImportPage from './HolidayImportPage';

export default HolidayImportPage;
